export const extendStringPrototipe = () => {


  String.prototype.toNumber = function (locale: string = "es-AR"): number {
    const decimal = (1.1).toLocaleString(locale).charAt(1);
    const thousandFormat = (10000).toLocaleString(locale);
    const group = thousandFormat.length>5 ? (10000).toLocaleString(locale).charAt(2):"";

    let str = this.trim();
    if (group !== decimal && group !="") str = str.replaceAll(group, '');
    if (decimal !== '.') str = str.replace(decimal, '.');

    return Number(str);

  }

}
    
